import React, { useRef } from 'react'

import {
  dateColDefs,
  defaultMultipleSelectionHeaderColumn,
} from '@/constants/ag-grid-scenario-builder.constant'
import { optimizationDefaultColDefs } from '@/constants/portfolioOptimization.constant'
import { IScreeningItemPortfolios } from '@/interfaces/portfolioOptimization.interface'
import { portfolioOptimizationDefaultGridOptions } from '@/utils/grid-utils/colDefs'
import { ColDef, GridOptions, RowSelectedEvent } from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import { Box } from '@mui/material'

type ScreenCriteriaPortfolioGridProps = {
  onSelectPortfolios: (portfolios: IScreeningItemPortfolios[]) => void
  availablePortfolios: IScreeningItemPortfolios[]
}

export const ScreenCriteriaPortfolioGrid: React.FC<
  ScreenCriteriaPortfolioGridProps
> = ({
  onSelectPortfolios,
  availablePortfolios,
}: ScreenCriteriaPortfolioGridProps) => {
  const gridRef = useRef<AgGridReact>(null)
  const gridOptions: GridOptions = {
    ...portfolioOptimizationDefaultGridOptions,
    rowData: availablePortfolios,
    sideBar: false,
    noRowsOverlayComponentParams: () => {
      return {
        noRowsMessage: 'No portfolios available.',
      }
    },
    rowSelection: 'multiple' as const,
    columnDefs: [
      {
        ...defaultMultipleSelectionHeaderColumn,
        suppressHeaderMenuButton: true,
        sortable: false,
        filter: false,
      },
      {
        ...{ ...optimizationDefaultColDefs, ...dateColDefs },
        headerName: 'Date',
        field: 'date',
        filter: 'agDateColumnFilter',
      },
      {
        ...optimizationDefaultColDefs,
        headerName: 'Portfolio Name/Benchmark Name',
        field: 'shortName',
        cellDataType: 'text',
        filter: 'agTextColumnFilter',
      },
      {
        ...optimizationDefaultColDefs,
        headerName: 'Type',
        field: 'typeAbbrev',
        cellDataType: 'string',
        filter: 'agTextColumnFilter',
      },
      {
        ...optimizationDefaultColDefs,
        headerName: 'Securities',
        field: 'numSec',
        cellDataType: 'number',
        filter: 'agNumberColumnFilter',
      },
      {
        ...optimizationDefaultColDefs,
        headerName: 'User',
        field: 'managerName',
        cellDataType: 'string',
        filter: 'agTextColumnFilter',
      },
    ] as ColDef[],
    onRowSelected: (params: RowSelectedEvent) => {
      const nodes = params.api.getSelectedNodes()
      onSelectPortfolios(nodes.map((node) => node.data))
    },
  }

  return (
    <>
      <Box
        className='ag-theme-quartz screen-criteria-portfolio-grid-table'
        sx={{ width: '100%', height: '100%', margin: 0 }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={availablePortfolios}
          gridOptions={gridOptions}
          data-cy='screen-criteria-portfolio-ag-grid'
        ></AgGridReact>
      </Box>
    </>
  )
}
